const DeleteIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66669 5.00033C1.66669 4.54009 2.03978 4.16699 2.50002 4.16699H17.5C17.9603 4.16699 18.3334 4.54009 18.3334 5.00033C18.3334 5.46056 17.9603 5.83366 17.5 5.83366H2.50002C2.03978 5.83366 1.66669 5.46056 1.66669 5.00033Z"
        fill="#857F8B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16665 4.16699C4.62688 4.16699 4.99998 4.54009 4.99998 5.00033V16.667C4.99998 16.8126 5.08119 17.028 5.27674 17.2236C5.47228 17.4191 5.68767 17.5003 5.83331 17.5003H14.1666C14.3123 17.5003 14.5277 17.4191 14.7232 17.2236C14.9188 17.028 15 16.8126 15 16.667V5.00033C15 4.54009 15.3731 4.16699 15.8333 4.16699C16.2936 4.16699 16.6666 4.54009 16.6666 5.00033V16.667C16.6666 17.3547 16.3312 17.9726 15.9017 18.4021C15.4723 18.8315 14.8543 19.167 14.1666 19.167H5.83331C5.14562 19.167 4.52768 18.8315 4.09822 18.4021C3.66877 17.9726 3.33331 17.3547 3.33331 16.667V5.00033C3.33331 4.54009 3.70641 4.16699 4.16665 4.16699Z"
        fill="#857F8B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77674 2.77643C7.58119 2.97198 7.49998 3.18737 7.49998 3.33301V4.99967C7.49998 5.45991 7.12688 5.83301 6.66665 5.83301C6.20641 5.83301 5.83331 5.45991 5.83331 4.99967V3.33301C5.83331 2.64531 6.16877 2.02737 6.59822 1.59792C7.02768 1.16846 7.64562 0.833008 8.33331 0.833008H11.6666C12.3543 0.833008 12.9723 1.16846 13.4017 1.59792C13.8312 2.02737 14.1666 2.64531 14.1666 3.33301V4.99967C14.1666 5.45991 13.7936 5.83301 13.3333 5.83301C12.8731 5.83301 12.5 5.45991 12.5 4.99967V3.33301C12.5 3.18737 12.4188 2.97198 12.2232 2.77643C12.0277 2.58089 11.8123 2.49967 11.6666 2.49967H8.33331C8.18767 2.49967 7.97228 2.58089 7.77674 2.77643Z"
        fill="#857F8B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33333 8.33301C8.79357 8.33301 9.16667 8.7061 9.16667 9.16634V14.1663C9.16667 14.6266 8.79357 14.9997 8.33333 14.9997C7.8731 14.9997 7.5 14.6266 7.5 14.1663V9.16634C7.5 8.7061 7.8731 8.33301 8.33333 8.33301Z"
        fill="#857F8B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6666 8.33301C12.1269 8.33301 12.5 8.7061 12.5 9.16634V14.1663C12.5 14.6266 12.1269 14.9997 11.6666 14.9997C11.2064 14.9997 10.8333 14.6266 10.8333 14.1663V9.16634C10.8333 8.7061 11.2064 8.33301 11.6666 8.33301Z"
        fill="#857F8B"
      />
    </svg>
  );
};

export default DeleteIcon;
